import { format } from 'date-fns';

export function toDateInputValue(d?: Date): string {
  const date = d ?? new Date();
  return format(date, 'yyyy-MM-dd');
}

export default toDateInputValue;
